<app-admin-header style="width: 100%;" [header]="header" [links]="links" [breadcrumbs]="breadcrumbs"
    [stats]="[]"></app-admin-header>
<div class="w-100">
    <app-skelitions [hidden]="!isSkelition" [value]="2" class="mb-2"></app-skelitions>
</div>
<section *ngIf="!isSkelition" class="container-fluid ms-main-bg py-5">
    <div class="container ms-pg-structure">
        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h">{{'Evaluation' | translator}}</h4>
            </div>
            <app-project-step [step]="'Evaluation'" [projectId]="projectId"></app-project-step>
        </div>
        <p-messages [(value)]="messages" [enableService]="false"></p-messages>
        <app-project-details-card *ngIf="basicChannelsProject && project && !isSkelition" [project]="project"
            [channels]="basicChannelsProject" [branches]="selectedBranchesProject"></app-project-details-card>
        <div class="white-box">
            <ng-container *ngIf="evaluations && evaluations.length > 0">
                <h4 class="medium-h my-4 mx-2">{{'Evaluation' | translator}}</h4>
                <div class="grey-box">
                    <table>
                        <thead>
                            <tr>
                                <th scope="col" style="width: 3%;" >#</th>
                                <th scope="col" style="width: 50%;">{{'Channel' | translator}}</th>
                                <th scope="col" style="width: 24%;">{{'Visit time' | translator}}</th>
                                <th scope="col" style="width: 20%;">{{'Status' | translator}}</th>
                                <th scope="col" style="width: 3%;">{{'Action' | translator}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let evaluation of evaluations;let i=index">
                                <td data-label="">
                                    <span class="ms-tabel-td-mob-mr">
                                        <div class="d-flex adjustment">
                                            <div class="tab-num-border-white">
                                                <div class="ms-tabel-num-box">
                                                    {{ i + 1 }}
                                                </div>
                                            </div>
                                        </div>
                                    </span>
                                </td>
                                <td data-label="Factor List">
                                    <span class="ms-tabel-td-mob-mr">
                                        
                                        <div class="tabel-detail-box m-adjust">
                                            {{ (evaluation.channel.name === 'Branches') ? evaluation.channel.name + ' ( ' + GetBranchName(evaluation.branch._id) + ' ) ' : evaluation.channel.name }}
                                    </div>
                                        <!-- <input type="text" class="form-control ms-input-white-pg-5"
                                                [disabled]="true"
                                                [value]="(evaluation.channel.name === 'Branches') ? evaluation.channel.name + ' ( ' + GetBranchName(evaluation.branch._id) + ' ) ' : evaluation.channel.name" > -->
                                    </span>
                                </td>
                                <td data-label="Employee Answer">
                                    <span class="ms-tabel-td-mob-mr">
                                        <div class="tabel-detail-box-input" >
                                            <input type="text" class="form-control ms-input-white-pg-v4"
                                                [disabled]="true"
                                                [value]="formatDate(evaluation.visitTime)" >
                                        </div>
                                    </span>
                                </td>
                                <td data-label="Employee Answer">
                                    <span class="ms-tabel-td-mob-mr">
                                        <div class="tabel-detail-box-input" >
                                            <input type="text" class="form-control ms-input-white-pg-v4"
                                                [disabled]="true"
                                                [value]="(evaluation.approvalStatus === undefined) ? ('Not Submitted' | translator) : (evaluation.approvalStatus | translator)">
                                        </div>
                                    </span>
                                </td>
                                <td data-label="">
                                    <span class="ms-tabel-td-mob-mr">
                                        <div class="d-flex adjustment">
                                            <div class="tab-num-border-white">
                                                <div class="ms-tabel-num-box pointer" (click)="viewEvaluation(evaluation)">
                                                    <i class="fa fa-eye"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </ng-container>
            <div *ngIf="basicChannels.length > 0 && !(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null))" class="grey-box">
             <div class="row">
                <div class="col-md-4 col-12">
                    <div>
                        <h4 class="medium-h my-2">{{'Channel' | translator}}</h4>
                        <div class="pppp-drop">
                            <p-dropdown [options]="basicChannels" [(ngModel)]="selectChanel" optionLabel="name" appendTo="body"
                                (onChange)="onChannelChange()" [placeholder]="'Select Channel' | translator "></p-dropdown>
                        </div>
                    </div>
                </div>
                <div *ngIf="hasBranches && selectChanel && selectChanel.name == 'Branches'" class="col-md-4 col-12">
                    <div>
                        <h4 class="medium-h my-2">{{'Branches' | translator}}</h4>
                        <div class="pppp-drop">
                            <p-dropdown [options]="selectedBranches" [(ngModel)]="selectBranch" optionLabel="name" appendTo="body"
                                (onChange)="onBranchChange()" [placeholder]="'Select Branch' | translator"></p-dropdown>
                        </div>
                    </div>
                </div>
                <div *ngIf="selectChanel" class="col-md-4 col-12">
                    <div>
                        <h4 class="medium-h my-2">{{'Visit Time' | translator}}</h4>
                        <div class="pppp-drop">
                            <p-dropdown [options]="filteredVisits" [(ngModel)]="selectVisit" optionLabel="dropdownlabel" appendTo="body"
                                (onChange)="onVisitChange()" [placeholder]="'Select a Visit' | translator"></p-dropdown>
                        </div>
                    </div>
                </div>
             </div>
            </div>
            <ng-container *ngIf="canSave">
                <h4 class="medium-h my-4 mx-2">{{'Enquires List' | translator}}</h4>
                <div class="grey-box">
                    <div (click)="showEnquiryModal = true" class="ms-plus-btn mx-2 pointer">
                        <i class="pi pi-plus-circle"></i>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th scope="col" style="width: 3%;" >#</th>
                                <th scope="col" style="width: 50%;">{{'Enquries List' | translator}}</th>
                                <th scope="col" style="width: 24%;">{{'Employee Answer' | translator}}</th>
                                <th scope="col" style="width: 24%;">{{'Mystery Shopper Comment' | translator}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let enquiry of selectedEnquiries;let i=index">
                                <td data-label="">
                                    <span class="ms-tabel-td-mob-mr">
                                        <div class="d-flex tab-num-border-white">
                                            <div>
                                                <div class="ms-tabel-num-box">
                                                    {{ i + 1 }}
                                                </div>
                                            </div>
                                        </div>
                                    </span>
                                </td>
                                <td data-label="Factor List">
                                    <span class="ms-tabel-td-mob-mr">
                                        <div class="tabel-detail-box">
                                            {{ enquiry.enquiry }}
                                        </div>
                                    </span>
                                </td>
                                <td data-label="Employee Answer">
                                    <span class="ms-tabel-td-mob-mr">
                                        <div class="tabel-detail-box-input" >
                                            <input type="text" class="form-control ms-input-white-pg-5"
                                                [(ngModel)]="enquiry.employeeAnswer" placeholder="Employee Answer" >
                                        </div>
                                    </span>
                                </td>
                                <td data-label="Employee Answer">
                                    <span class="ms-tabel-td-mob-mr">
                                        <div class="tabel-detail-box-input">
                                            <input type="text" class="form-control ms-input-white-pg-5"
                                                [(ngModel)]="enquiry.msComments" [placeholder]="'Comments' | translator" >
                                        </div>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h4 class="medium-h my-4 mx-2">{{'Factors List' | translator}}</h4>
                <div class="grey-box">
                    <table>
                        <thead>
                            <tr>
                                <th scope="col" style="width: 3%;">#</th>
                                <th scope="col" style="width: 50%;">{{'Factor' | translator}}</th>
                                <th scope="col" style="width: 7%;">{{'Grade/5' | translator}}</th>
                                <th scope="col" style="width: 40%;">{{'Comments' | translator}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let factor of factors;let i=index">
                                <td data-label="">
                                    <span class="ms-tabel-td-mob-mr">
                                        <div class="d-flex tab-num-border-white">
                                            <div>
                                                <div class="ms-tabel-num-box">
                                                    {{ i + 1 }}
                                                </div>
                                            </div>
                                        </div>
                                    </span>
                                </td>
                                <td data-label="Factor List">
                                    <span class="ms-tabel-td-mob-mr">
                                        <div class="tabel-detail-box">
                                            {{ factor.factor }}
                                        </div>
                                    </span>
                                </td>
                                <td data-label="Employee Answer">
                                    <span class="ms-tabel-td-mob-mr">
                                        <div class="tabel-detail-box-input">
                                            <p-inputNumber [disabled]="(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null))" inputId="integeronly" class="111 input-number-field p-input-num-v4" [styleClass]="'calender-hide'"
                                                [min]="0" [max]="5" [inputStyle]="{ 'width': '100%', 'height': '100%', 'text-align': 'center', 'margin-top': '0px'}"
                                                [(ngModel)]="factor.grade"
                                            />
                                        </div>
                                    </span>
                                </td>
                                <td data-label="Employee Answer">
                                    <span class="ms-tabel-td-mob-mr">
                                        <div class="tabel-detail-box-input">
                                            <input type="text" class="form-control ms-input-white-pg-v4 mb-0 mt-0"
                                                [(ngModel)]="factor.msComments" [placeholder]="'Comments' | translator" >
                                        </div>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </ng-container>
            <ng-container *ngIf="!canSave && filteredEvaluation.length > 0">
                <h4 class="medium-h my-4 mx-2">{{'Enquries List' | translator}}</h4>
                <div class="grey-box">
                    <table>
                        <thead>
                            <tr>
                                <th scope="col" style="width: 3%;" >#</th>
                                <th scope="col" style="width: 40%;">{{'Enquries List' | translator}}</th>
                                <th scope="col" style="width: 34%;">{{'Employee Answer' | translator}}</th>
                                <th scope="col" style="width: 24%;">{{'Mystery Shopper Comment' | translator}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let enquiry of filteredEvaluation[0].enquiries;let i=index">
                                <td data-label="">
                                    <span class="ms-tabel-td-mob-mr">
                                        <div class="d-flex tab-num-border-white">
                                            <div>
                                                <div class="ms-tabel-num-box">
                                                    {{ i + 1 }}
                                                </div>
                                            </div>
                                        </div>
                                    </span>
                                </td>
                                <td data-label="Factor List">
                                    <span class="ms-tabel-td-mob-mr">
                                        <div class="tabel-detail-box">
                                            {{ enquiry.enquiry }}
                                        </div>
                                    </span>
                                </td>
                                <td data-label="Employee Answer">
                                    <span class="ms-tabel-td-mob-mr">
                                        <div class="tabel-detail-box-input" [ngStyle]="{'margin-top' :'20px'}">
                                            <input type="text" [disabled]="canUpdate ? false : true" class="form-control ms-input-white-pg-v4"
                                                [(ngModel)]="enquiry.employeeAnswer" placeholder="Employee Answer" >
                                        </div>
                                    </span>
                                </td>
                                <td data-label="Employee Answer">
                                    <span class="ms-tabel-td-mob-mr">
                                        <div class="tabel-detail-box-input" [ngStyle]="{'margin-top' :'20px'}" >
                                            <input type="text" class="form-control ms-input-white-pg-v4"
                                                [disabled]="canUpdate ? false : true"
                                                [(ngModel)]="enquiry.msComments" [placeholder]="'Comments' | translator" >
                                        </div>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h4 class="medium-h my-4 mx-2">{{'Factors List' | translator}}</h4>
                <div class="grey-box">
                    <table>
                        <thead>
                            <tr>
                                <th scope="col" style="width: 3%;">#</th>
                                <th scope="col" style="width: 50%;">{{'Factor' | translator}}</th>
                                <th scope="col" style="width: 7%;">{{'Grade/5' | translator}}</th>
                                <th scope="col" style="width: 7%;">{{'Percentage' | translator}}</th>
                                <th scope="col" style="width: 40%;">{{'Comments' | translator}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let factor of filteredEvaluation[0].factors;let i=index">
                                <td data-label="">
                                    <span class="ms-tabel-td-mob-mr">
                                        <div class="d-flex  adjustment">
                                            <div class="tab-num-border-white">
                                                <div class="ms-tabel-num-box">
                                                    {{ i + 1 }}
                                                </div>
                                            </div>
                                        </div>
                                    </span>
                                </td>
                                <td data-label="Factor List">
                                    <span class="ms-tabel-td-mob-mr">
                                        <!-- <div class="tabel-detail-box">
                                            {{ factor.factor }}
                                        </div> -->
                                        <div class="tabel-detail-box-input">
                                            <input type="text" class="form-control ms-input-white-pg-v4"
                                                [disabled]="canUpdate ? false : true"
                                                [(ngModel)]="factor.factor" [placeholder]="'Comments' | translator" >
                                        </div>
                                    </span>
                                </td>
                                <td data-label="Employee Answer">
                                    <span class="adjustment">
                                        <div class="tabel-detail-box-input ppp-num">
                                            <p-inputNumber [disabled]="(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null))" inputId="integeronly" class="222 111 input-number-field p-input-num-v4" [styleClass]="'calender-hide'"
                                                [min]="0" [max]="5" [inputStyle]="{ 'width': '100%', 'height': '100%', 'text-align': 'center', 'margin-top': '0px'}"
                                                [disabled]="canUpdate ? false : true"
                                                [(ngModel)]="factor.grade"
                                            />
                                        </div>
                                    </span>
                                </td>
                                <td data-label="Employee Answer">
                                    <span class="adjustment">
                                        <div class="tabel-detail-box-input ppp-num">
                                            <p-inputNumber [disabled]="true" class="333 222 111 input-number-field p-input-num-v4" [styleClass]="'calender-hide'"
                                                [inputStyle]="{ 'width': '100%', 'height': '100%', 'text-align': 'center', 'margin-top': '0px'}"
                                                [(ngModel)]="factor.percentage"
                                            />
                                        </div>
                                    </span>
                                </td>
                                <td data-label="Employee Answer">
                                    <span class="ms-tabel-td-mob-mr">
                                        <div class="tabel-detail-box-input">
                                            <input type="text" class="form-control ms-input-white-pg-v4"
                                                [disabled]="canUpdate ? false : true"
                                                [(ngModel)]="factor.msComments" [placeholder]="'Comments' | translator" >
                                        </div>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </ng-container>
        </div>
        <ng-container *ngIf="canSave || canUpdate || evaluationStatus == 'Pending'">
            <div class="my-4 bg-comment-color mx-1">
                <h5 class="medium-h-v4 p-3">{{'PM Comments' | translator}}</h5>
                <input class="ms-input-textarea" type="textarea"
                    [disabled]="evaluationStatus == 'Pending' ? true : false"
                    [(ngModel)]="pmComment" placeholder="">
            </div>
            <div class="d-flex justify-content-center gap-1">
                <button *ngIf="evaluationStatus != 'Pending'" (click)="canUpdate ? updateEvaluation() : saveEvaluation()" class="next-btn">{{'Save' | translator}}</button>
                <button *ngIf="!(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)) && (evaluationStatus == '' || evaluationStatus == 'Redo' || evaluationStatus == 'Change') " (click)="updateEvaluationStatus('Pending')" class="next-btn">{{'SubmitMS' | translator}}</button>
            </div>
        </ng-container>
        <ng-container *ngIf="!canSave">
            <ng-container *ngIf="(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)) && evaluationStatus == 'Pending'">
                <div class="my-4 bg-comment-color mx-1">
                    <h5 class="medium-h-v4 p-3">{{'Comments' | translator}}</h5>
                    <input class="ms-input-textarea" type="textarea" 
                        [(ngModel)]="iPMComment" placeholder="">
                </div>
                <div class="d-flex justify-content-center gap-1">
                    <button (click)="updateEvaluationStatus('Redo')" class="re-do-btn mx-2">{{'Redo' | translator}} <i
                            class="fa-solid fa-arrows-rotate mx-2"></i></button>
                    <button (click)="updateEvaluationStatus('Approved')" class="next-btn">{{'Approve' | translator}} <i
                        class="pi pi-check-circle mx-2"></i></button>
                </div>
            </ng-container>
            <ng-container *ngIf="evaluationStatus != ''">
                <div class="my-4 bg-comment-color mx-1" align="center">
                    <h5 class="medium-h p-3" [ngClass]=" evaluationStatus == 'Approved' ? 'text-success' : (evaluationStatus == 'Change' ? '' : 'text-danger')">
                        <h5 class="medium-h p-3" [ngClass]=" evaluationStatus == 'Approved' ? 'text-success' : (evaluationStatus == 'Change' ? '' : (evaluationStatus == 'Pending' ? '' : 'text-danger'))">
                            <ng-container *ngIf="evaluationStatus === 'Change' || evaluationStatus === 'Pending'; else defaultTemplate">
                                {{ 'Evaluation' | translator }} {{ ('are in ' + evaluationStatus + ' State') | translator }}
                            </ng-container>
                            <ng-template #defaultTemplate>
                                {{ ('are in ' + evaluationStatus + ' State') | translator }} {{ (evaluationStatus == 'Approved') ?  ('Evaluation' | translator) : '' }}
                            </ng-template>
                        </h5>

                        <br><br>
                        <h5 *ngIf="evaluationStatus == 'Redo' || evaluationStatus == 'Change'" class="medium-h p-3">{{ iPMComment }}</h5>
                    </h5>
                </div>
            </ng-container>
            <ng-container *ngIf="(isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)) && evaluationStatus == 'Approved'">
                <div class="my-4 bg-comment-color mx-1">
                    <h5 class="medium-h-v4 p-3">{{'Comments' | translator}}</h5>
                    <input class="ms-input-textarea" type="textarea" 
                        [(ngModel)]="iPMComment" placeholder="">
                </div>
                <div class="d-flex justify-content-center gap-1">
                    <button (click)="updateEvaluationStatus('Change')" class="next-btn">{{'Request Change' | translator}}</button>
                </div>
            </ng-container>
        </ng-container>
    </div>
</section> 
<p-dialog [header]="'Add Enquiry' | translator" [(visible)]="showEnquiryModal" [style]="{width: '40vw'}">
    <ng-template pTemplate="body">
        <div class="d-flex" *ngFor="let enquiry of filteredEnquiries; let i = index">
            <div class="width-100">
                <div *ngIf="i == 0" class="d-flex align-items-center">
                    <div class="d-flex" [ngStyle]="{'margin-right.px': i === 0 ? 5 : 0}">
                        <div class="ms-check-box" (click)="checkAll(isCheckAll)">
                            <i *ngIf="isCheckAll" class="pi pi-check"></i>
                            <i *ngIf="!isCheckAll" class="pi pi-x"></i>
                        </div>
                    </div>
                    <div class="d-flex flex-wrap">
                        <h4 class="medium-h my-2">{{'Select All' | translator}}</h4>
                    </div>
                </div>
                <div class="white-box-check">
                    <div class="d-flex align-items-center">
                        <div class="d-flex">
                            <div class="ms-check-box" (click)=" (isInternalPM || isInternalUserPM((project != undefined) ? project.internalPm : null)) ? null : addRemoveEnquiry(enquiry)">
                                <i *ngIf="enquirySelected(enquiry)" class="pi pi-check"></i>
                                <i *ngIf="!enquirySelected(enquiry)" class="pi pi-x"></i>
                            </div>
                        </div>
                        <div class="d-flex flex-wrap">
                            <div class="ms-check-box-name">
                                <strong>
                                    {{ enquiry.enquiry }}
                                </strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</p-dialog>
<p-confirmDialog [style]="{margin: '0rem 1rem'}"></p-confirmDialog>
<app-footer></app-footer>